export default __webpack_public_path__ + "static/media/laval2.ff0ec4cd.jpg";